export default {
  submit: "Soumettre",
  search: "Rechercher",
  reset: "Réinitialiser",
  select: "Sélectionner",
  create: "Créer",
  update: "Mettre à jour",
  edit: "Modifier",
  delete: "Supprimer",
  add: "Ajouter",
  remove: "Retirer",
  cancel: "Annuler",
  save: "Enregistrer",
  saved: "Enregistré",
  loading: "Chargement...",
  error: "Erreur",
  success: "Succès",
  warning: "Avertissement",
  info: "Information",
  date: "Date",
  time: "Heure",
  today: "Aujourd'hui",
  yesterday: "Hier",
  tomorrow: "Demain",
  lastDays: "{days} derniers jours",
  upgrade: "Passer à la version supérieure",
  import: "Importer",
  export: "Exporter",
  ok: "OK",
  close: "Fermer",
  clear: "Effacer",
  retry: "Réessayer",
  upload: "Télécharger",
  row: "Ligne {row}",
  items: "éléments",
  yes: "Oui",
  no: "Non",
  utc: "UTC",
  london: "Londres",
  paris: "Paris",
  berlin: "Berlin",
  shanghai: "Shanghai",
  new_york: "New York",
  los_angeles: "Los Angeles",
  privacy_policy: "Voir la politique de confidentialité",
  email_placeholder: "Veuillez saisir votre email",
  empty_chart_action: "Calculer maintenant",
  preview: "Aperçu",
  sign_out: "Se déconnecter",
  invoice: "Facture",
  credit_notes: "Avoirs",
  filter: "Filtrer",
  trendChart: {
    export_image: "Exporter l'image",
    this_month: "Ce mois-ci",
    last_month: "Le mois dernier",
    month_before_last: "Avant-dernier mois",
    this_week: "Cette semaine",
    last_2_weeks: "2 dernières semaines",
    last_4_weeks: "4 dernières semaines",
    today: "Aujourd'hui",
    yesterday: "Hier",
    day_before_yesterday: "Avant-hier",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    export_failed: "Échec de l'exportation du graphique",
    export_retry: "Échec de l'exportation du graphique, veuillez réessayer",
  },
  view_all_news: "Voir toutes les actualités",
  confirm: "Confirmer",
  rangeSearch: "Recherche par intervalle",
  leg: {
    origin: "Origine",
    destination: "Destination",
    transportMode: "Mode de transport",
    distance: "Distance (km)",
    weight: "Poids (t)",
    cnCode: "Code NC",
    transportEmission: "Émission de transport (kg CO2e)",
    productionEmission: "Émission de production (kg CO2e)",
    totalEmission: "Émission totale (kg CO2e)",
  },
  previewReports: {
    pdfPreview: "Aperçu PDF",
    excelPreview: "Aperçu Excel",
    payPerUse: "Limite dépassée, payer à l'usage ?",
    payPerUseDownload: "Téléchargement à l'usage",
    download: "Télécharger",
    refresh: "Actualiser",
    darkModeWarning:
      "Le mode sombre est uniquement destiné à l'aperçu de l'interface et n'affecte pas les fichiers exportés. Les fichiers exportés conserveront un style de fond blanc",
    upgradeToUnlockExcel: "Passez à la version Pro pour débloquer l'aperçu Excel",
    unlockFeatures:
      "Débloquez l'exportation Excel, le logo personnalisé, le multilingue et d'autres fonctionnalités avancées pour améliorer le professionnalisme des rapports !",
    upgradeNow: "Passer à la version supérieure maintenant",
    previewFailed: "Échec de l'aperçu",
    excelPreviewRequiresPro: "L'aperçu Excel nécessite un abonnement Pro !",
    limitReached: "Limite quotidienne ou mensuelle atteinte",
    saved: "Enregistré avec succès, vous pouvez le consulter dans la liste des rapports",
  },
  select_status: "Sélectionner le statut",
  select_plan_type: "Sélectionner le type de plan",
  refund: "Remboursement",
  view: "Voir",
  start_date: "Date de début",
  end_date: "Date de fin",
  view_details: "Voir les détails",
  back_to_login: "Retour à la connexion",
  view_count_description:
    "Le nombre de vues représente le nombre total de fois où ce rapport a été consulté via le partage. Le dé-partage ne réinitialise pas ce compteur.",
  notify: {
    auto_renew: "Renouvellement automatique",
    auto_renew_desc:
      "Activer pour renouveler automatiquement votre abonnement à la fin du cycle de facturation.",
  },
  ticketTypes: {
    technical: "Problème technique",
    billing: "Problème de facturation",
    compliance: "Consultation de conformité",
    feedback: "Commentaires et suggestions",
    other: "Autre",
  },
  loading_verification: "Chargement de la vérification...",
  billing: {
    current_plan: "Plan actuel",
    upgrade: "Passer à la version supérieure",
    manage: "Voir la facturation",
    plan_type: "Type de plan",
    next_billing: "Prochaine date de facturation",
    expiry_date: "Date d'expiration",
    expired: "Expiré",
    permanent: "Permanent",
  },
  faq: {
    search_placeholder: "Rechercher dans les FAQ...",
    no_results_title: "Aucun résultat trouvé",
    no_results_subtitle:
      "Essayez d'ajuster vos mots-clés de recherche ou parcourez les catégories sur la gauche.",
    search_cleared_message: "Recherche effacée pour afficher le contenu complet",
    still_have_questions: {
      before_email: "Vous avez encore des questions ? Contactez-nous à ",
      after_email: " — notre équipe répondra dans un délai de 24 heures.",
    },
  },
};
